import React from 'react';

interface BorderRadiusIconProps {
    color?: string;
}

export const SquareBorderIcon: React.FC<BorderRadiusIconProps> = ({ color = 'var(--color-gray-900)' }) => (
    <svg viewBox="0 0 24 24" className="w-full h-full" preserveAspectRatio="xMidYMid meet">
        <path
            d="M2 20 L2 2 L20 2"
            stroke={color}
            fill="none"
            strokeWidth="1.5"
        />
    </svg>
);

export const SmoothBorderIcon: React.FC<BorderRadiusIconProps> = ({ color = 'var(--color-gray-900)' }) => (
    <svg viewBox="0 0 24 24" className="w-full h-full" preserveAspectRatio="xMidYMid meet">
        <path
            d="M2 20 L2 6 C2 3.79086 3.79086 2 6 2 L20 2"
            stroke={color}
            fill="none"
            strokeWidth="1.5"
        />
    </svg>
);

export const RoundedBorderIcon: React.FC<BorderRadiusIconProps> = ({ color = 'var(--color-gray-900)' }) => (
    <svg viewBox="0 0 24 24" className="w-full h-full" preserveAspectRatio="xMidYMid meet">
        <path
            d="M2 20 L2 10 C2 5.58172 5.58172 2 10 2 L20 2"
            stroke={color}
            fill="none"
            strokeWidth="1.5"
        />
    </svg>
); 